import { HeroBanner } from './hero-banner';
import { ProductHeader } from './product-header';
import { SplitScreen } from './split-screen';
import { TabGroup } from './tab-group';
import { Upsells } from './upsells';

export class Blocks {


    /**
     * The various blocks to initialise.
     *
     * @private
     * @memberof Blocks
     */
    private blocks = {
        '.js-split-screen': SplitScreen,
        '.js-hero-banner': HeroBanner,
        '.js-product-header': ProductHeader,
        '.js-tab-group': TabGroup,
        '.js-upsells': Upsells
    };


    /**
     * Creates a new instance of Blocks
     */
    constructor() {
        $.each(this.blocks, (className, block) => {
            const blockElements = $(className);

            blockElements.each(({}, blockElement) => {
                new block(blockElement);
            });
        });
    }
}
